export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "quality_template": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspección de calidad"])},
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])}
          }
        }
      },
      "en": {
        "model": {
          "quality_template": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspection"])},
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])}
          }
        }
      }
    }
  })
}